import { Constants, CYBER_CONSTANT } from 'constants';

import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Grid,
  Spinner,
  DropdownItem,
  Drawer,
  Tooltip,
  useMediaQuery,
  Button,
  AccessControl,
  AccessControlProvider,
  Dropdown,
} from '@genie-ui/react';
import ConfigPath from 'configpath';
import { useDispatch, useSelector } from 'react-redux';
import { useIntercom } from 'react-use-intercom';
import { format } from 'date-fns';

import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import DrawerComponent from 'components/atoms/drawercomponent';
import SnackbarComponent from 'components/atoms/snackbarcomponent';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import {
  valueObject,
  objValueExist,
  isEmptyValue,
  drawerCategory,
  getStateFromPercentile,
  countOccurrences,
  trimText,
} from 'utils';
import ErrorPage from 'components/pages/errorpage';
// TODO: Below code in needed for next MVP
// import CyberComparisonSelectedFilter from 'components/atoms/cybercomparisonselectedfilters';
import CyberLegends from 'components/molecules/cyberlegends';
import KpiCard from 'components/organisms/kpicard';
import ComparisonDialog from 'components/organisms/comparisondialog';
import CarousalComponent from 'components/atoms/carousalcomponent';
import GravityLayout from 'components/atoms/gravitylayout';
import {
  setActisData,
  setIsChinese,
  setIsVersionTwoEnabled,
  setCurrentKpi,
  setOpenDrawer,
  setKpiData,
  setCurrentRR,
  setMinimalBenchmarkData,
  setBenchmarkForKpiData,
  setShowPrint,
  setCurrentDashboardDetails,
  setAllDashboardDetails,
  setCohortSelection,
  // TODO: Below code in needed for next MVP
  // setCohortList,
} from 'stores/slice';
import CyberFirstContainer from 'components/molecules/cyberfirstcontainer';
import AssignTeam from 'components/organisms/assignTeam';

import {
  fetchOrgDetails,
  postOrgDetails,
  fetchSubIndustries,
  getKpiList,
  getKpiResources,
  // TODO: Below code in needed for next MVP
  // fetchCohort,
  fetchMinimalUserBenchmark,
  fetchBenchmarkForKpi,
  fetchTeamMembers,
  getOverallRR,
} from './api';
import './Cyber.scss';

function Cyber({ actisDataObj, userData }) {
  const dispatch = useDispatch();
  const {
    actisData, showPrint, isVersionTwoEnabled, openDrawer, currentKpi, kpiData,
    minimalBenchmarkData, benchmarkForKpiData,
  } = useSelector((state) => state.cyber);
  const {
    currentDashboardDetails,
    allDashboardDetails,
    cohortSelection,
  } = useSelector((state) => state.auth);
  const [showLoader, setShowLoader] = useState(false);
  const [showResourcesLoader, setShowResourcesLoader] = useState(false);
  const [showErrorComponent, setShowErrorComponent] = useState(false);
  const [checkKpiData, setCheckKpiData] = useState([]);
  const [openDialogGroup, setOpenDialogGroup] = useState(false);
  const [acceptDialog, setAcceptDialog] = useState(false);
  const [selectedValues, setSelectedValues] = useState({});
  const [defaultValues, setDafaultValues] = useState({});
  const [restoreValues, setRestoreValues] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [groupValues, setGroupValues] = useState({});
  const [shareDialogStatus, setShareDialogStatus] = useState(false);
  const [optIn, setOptIn] = useState(false);
  const [dialog, setDialog] = useState(CYBER_CONSTANT.DIALOG);
  const [showSubmit, setShowSubmit] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [kpiResources, setKpiResources] = useState();
  const [currentView, setCurrentView] = useState(true);
  const [isLoadingBenchmark, setIsLoadingBenchmark] = useState(false);
  const [recommendedTools, setRecommendedTools] = useState([]);
  const [recommendedResources, setRecommendedResources] = useState([]);
  const { boot: bootIntercom } = useIntercom();
  const isResponsive = useMediaQuery('(min-width:900px)');
  const [shouldShowTooltip, setShouldShowTooltip] = useState(false);
  const [statusBadges, setStatusBadges] = useState([]);

  const [dashboardList, setDashboardList] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [inviteMemberCount, setInviteMemberCount] = useState(0);
  const [localKpiDatas, setLocalKpiDatas] = useState([]);

  useEffect(() => {
    dispatch(
      setActisData({ ...actisDataObj }),
    );
  }, []);

  useEffect(() => {
    if (ConfigPath.IS_PROD) {
      setTimeout(() => {
        bootIntercom({
          email: userData?.userDetails?.primaryEmailDec,
          name: userData?.userDetails?.firstName,
          customAttributes: {
            gartner_user: userData?.userDetails?.companyNameDec?.includes(
              CYBER_CONSTANT.GARTNER_NAME,
            ),
          },
        });
      }, CYBER_CONSTANT.INTERCOM.DELAY);
    }
  }, []);

  useEffect(() => {
    if (actisData?.primaryEmail) {
      window.pushEvent?.(
        {
          ...Constants.ACTIS.LOGIN,
          ...actisData,
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    }
  }, [actisData]);

  const checkAndUpdateView = (kpiList = kpiData) => {
    if (
      kpiList?.some((item) => item.tarValue)
      && kpiList?.every((item) => !item.curValue)
    ) {
      setCurrentView(false);
    }

    if (
      kpiList?.some((item) => item.curValue)
      && kpiList?.every((item) => !item.tarValue)
    ) {
      setCurrentView(true);
    }
  };

  const fetchMinimalBenchmarkData = (values) => fetchMinimalUserBenchmark(
    values,
  ).then((data) => {
    dispatch(setMinimalBenchmarkData(data?.body?.minimalBenchmark || {}));
  });

  const fetchBenchmarkForKpiData = (values = cohortSelection) => {
    setIsLoadingBenchmark(true);
    fetchBenchmarkForKpi(currentDashboardDetails?.dashboardId, values)
      .then((data) => {
        dispatch(setBenchmarkForKpiData(data?.body || {}));
      })
      .finally(() => {
        setIsLoadingBenchmark(false);
      });
  };

  // fetch kpi details and gcom filters data
  useEffect(() => {
    setShowLoader(true);

    getKpiList(currentDashboardDetails?.dashboardId).then(
      (dataCopy) => {
        if (dataCopy?.body) {
          const tempArr = [];
          dataCopy?.body?.kpiList?.forEach((item) => {
            tempArr.push({
              ...item,
              error: false,
            });
          });
          dispatch(setKpiData(tempArr));
          setCheckKpiData(tempArr);
          setLocalKpiDatas(tempArr);
        } else {
          setShowErrorComponent(true);
        }
      },
      () => {
        setShowErrorComponent(true);
      },
    );

    getOverallRR().then(
      (overallRR) => {
        if (overallRR?.body) {
          setRecommendedTools(overallRR?.body?.recommendedTools);
          setRecommendedResources(overallRR?.body?.recommendedResources);
        }
      },
    );
    fetchOrgDetails(currentDashboardDetails?.dashboardId).then(
      (data) => {
        if (data?.body) {
          const values = {
            selectedIndustry: {
              ...valueObject(data?.body?.industry, data?.body?.selectedIndustry),
              openDropdown: false,
            },
            selectedSubIndustry: {
              ...valueObject(
                data?.body?.subIndustry,
                data?.body?.selectedSubIndustry,
              ),
              openDropdown: false,
            },
            selectedRevenue: {
              ...valueObject(data?.body?.revenue, data?.body?.selectedRevenue),
              openDropdown: false,
            },
            selectedHeadquarter: {
              ...valueObject(
                data?.body?.headquarter,
                data?.body?.selectedHeadquarter,
              ),
              openDropdown: false,
            },
          };
          setAcceptDialog(data?.body?.showConfirmDetails);
          setOptIn(data?.body?.optInSelected);
          setSelectedValues(values);
          setGroupValues(values);
          setDashboardList(data?.body?.dashboardList);
          setPermissions(data?.body?.permissions || []);
          dispatch(setCohortSelection(data?.body?.cohortSelection || {}));
          dispatch(
            setIsChinese(
              data?.body?.hasDataPrivacyPersonalizationPolicy
                || data?.body?.countryCode?.toLowerCase()
                  === CYBER_CONSTANT.LABEL.CHN,
            ),
          );
          setDafaultValues({
            industry: data?.body?.industry,
            subIndustry: data?.body?.subIndustry,
            revenue: data?.body?.revenue,
            headquarter: data?.body?.headquarter,
          });
          dispatch(setIsVersionTwoEnabled(data?.body?.isVersionTwoEnabled));
          // TODO: Below code in needed for next MVP
          // if (data?.body?.isVersionTwoEnabled) {
          //   fetchCohort(currentDashboardDetails?.dashboardId, data?.body?.cohortSelection).then(
          //     (dataLocal) => {
          //       if (dataLocal?.body) {
          //         dispatch(setCohortList(dataLocal?.body?.cohort));
          //       }
          //     },
          //   );
          // }
          setShowLoader(false);
        }
      },
      () => {
        setShowErrorComponent(true);
        setShowLoader(false);
      },
    );

    setShowResourcesLoader(true);
    getKpiResources().then(
      (dataGet) => {
        if (dataGet?.body) {
          dispatch(setCurrentRR(dataGet?.body?.recommendedResources));
          setKpiResources(dataGet?.body);
          setShowResourcesLoader(false);
        } else {
          setShowResourcesLoader(false);
        }
      },
      () => {
        setShowResourcesLoader(false);
      },
    );
  }, [currentDashboardDetails?.dashboardId]);

  useEffect(() => {
    if (currentDashboardDetails?.dashboardId) {
      fetchTeamMembers(currentDashboardDetails?.dashboardId)?.then((response) => {
        if (response?.body) {
          const { data } = response?.body || {};
          setInviteMemberCount(data?.length);
        }
      });
    }
  }, [currentDashboardDetails?.dashboardId]);

  useEffect(() => {
    if (isVersionTwoEnabled && currentDashboardDetails?.dashboardId) {
      fetchMinimalBenchmarkData(cohortSelection);
      fetchBenchmarkForKpiData(cohortSelection);
    }
  }, [cohortSelection]);

  // open/close drawer
  const sideDrawer = (val, index) => () => {
    if (val) {
      if (acceptDialog) {
        dispatch(setOpenDrawer(val));
      } else {
        setOpenDialogGroup(val);
      }
      setRestoreValues(defaultValues);
      setShowSubmit(objValueExist(selectedValues));

      window.pushEvent?.(
        {
          ...CYBER_CONSTANT.ACTIS.DRAWER_OPEN,
          ...actisData,
          activityMeta: `User clicks on '${kpiData[index]?.header}' kpi card`,
          activityValue: 'true',
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    } else {
      dispatch(setOpenDrawer(val));
      window.pushEvent?.(
        {
          ...CYBER_CONSTANT.ACTIS.DRAWER_CLOSE,
          ...actisData,
          activityCategory: drawerCategory(index, kpiData, checkKpiData),
          activityMeta: `User closes '${kpiData[index]?.header}' drawer`,
          activityValue: `${
            isEmptyValue(kpiData[index]?.curValue)
              ? `Current: ${kpiData[index]?.curValue} ${kpiData[index]?.unit}, `
              : ''
          }${
            isEmptyValue(kpiData[index]?.tarValue)
              ? `Target: ${kpiData[index]?.tarValue} ${kpiData[index]?.unit}, `
              : ''
          }Current Estimate Check: ${kpiData[index]?.curEstimateCheck}`,
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
      setCheckKpiData(kpiData);
    }
    dispatch(setCurrentKpi(index));
  };

  const closeShareDialog = (inviteeCount) => {
    setShareDialogStatus(false);
    setInviteMemberCount(inviteeCount);
  };

  const openShareDialog = () => {
    setShareDialogStatus(true);
    window.pushEvent?.(
      {
        ...CYBER_CONSTANT.ACTIS.MANAGE_ACCESS_OPEN,
        ...actisData,
      },
      Constants.LABELS.ACTIS_KEY_CYBER,
    );
  };

  // handle change of filters values
  const handleChange = (type, event, autoField) => {
    let values = {};
    if (!autoField) {
      Object.keys(defaultValues).forEach((orgFilter) => {
        defaultValues[orgFilter]?.forEach((item) => {
          if (item?.desc === event?.target?.textContent?.trim()) {
            if (type === 'selectedIndustry') {
              setSelectedValues((prev) => ({
                ...prev,
                [type]: {
                  ...item,
                  openDropdown: false,
                },
              }));
              fetchSubIndustries(item?.id).then(
                (responseData) => {
                  setDafaultValues((val) => ({
                    ...val,
                    subIndustry: responseData?.body?.subIndustry,
                  }));
                  values = {
                    ...selectedValues,
                    selectedIndustry: {
                      ...item,
                      openDropdown: false,
                    },
                    selectedSubIndustry: {
                      desc: null,
                      openDropdown: false,
                    },
                  };
                  setSelectedValues(values);
                  setShowSubmit(objValueExist(values));
                },
                () => {
                  setShowErrorComponent(true);
                },
              );
            } else {
              values = {
                ...selectedValues,
                [type]: {
                  ...item,
                  openDropdown: false,
                },
              };
              setSelectedValues(values);
              setShowSubmit(objValueExist(values));
            }
          }
        });
      });
    } else {
      if (autoField?.desc?.trim()) {
        values = {
          ...selectedValues,
          [type]: {
            ...autoField,
            openDropdown: false,
          },
        };
        setShowSubmit(objValueExist(values));
      } else if (!autoField?.target) {
        values = {
          ...selectedValues,
          [type]: {
            ...defaultValues.headquarter.filter(
              (val) => val.desc === autoField,
            )[0],
            openDropdown: false,
          },
        };
        setShowSubmit(objValueExist(values));
      } else {
        values = {
          ...selectedValues,
          [type]: {
            desc: autoField?.target?.value?.trim() || null,
            openDropdown: false,
          },
        };
        setShowSubmit(true);
      }
      setSelectedValues(values);
    }
  };

  const handleDisplayListClick = (type) => (e) => {
    handleChange(type, e);
  };

  // display filters list
  const displayList = (list, type) => list?.map((item) => (
    <DropdownItem
      key={item.desc}
      onClick={handleDisplayListClick(type)}
      className={
          item?.desc === selectedValues[type]?.desc
            ? CYBER_CONSTANT.DROPDOWN_ITEM
            : ''
        }
    >
      <Typography>{item.desc}</Typography>
    </DropdownItem>
  ));

  // handle dialog submit button call
  const handleAgree = (val) => {
    if (val) {
      setShowLoader(true);
      setGroupValues(selectedValues);
      postOrgDetails(selectedValues).then(
        (data) => {
          if (!data?.body) {
            setShowErrorComponent(true);
          } else {
            setAcceptDialog(val);
            dispatch(setOpenDrawer(val));
            setOptIn(val);
            setOpenDialogGroup(false);
            dispatch(setCurrentDashboardDetails(data?.body?.currentDashboard));
            dispatch(setAllDashboardDetails(data?.body?.dashboardList));
          }
          setShowLoader(false);
        },
        () => {
          setShowErrorComponent(true);
          setShowLoader(false);
        },
      );

      window.pushEvent?.(
        {
          ...CYBER_CONSTANT.ACTIS.FILTER_AGREE,
          ...actisData,
          activityValue: `Filter_Values-
            Industry: ${selectedValues?.selectedIndustry?.desc},
            Subindustry: ${selectedValues?.selectedSubIndustry?.desc},
            Revenue: ${selectedValues?.selectedRevenue?.desc},
            Headquarter: ${selectedValues?.selectedHeadquarter?.desc},
            optInSelected: true,
            showConfirmDetails: true`,
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    } else {
      setOpenDialogGroup(val);
      setSelectedValues(groupValues);
      setDafaultValues(restoreValues);
      window.pushEvent?.(
        { ...CYBER_CONSTANT.ACTIS.FILTER_CANCEL, ...actisData },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    }
  };

  // close data save snackbar
  const handleSnackbar = () => {
    setShowSuccess(false);
  };

  const toggleCurrentView = (val) => () => {
    window.pushEvent?.(
      {
        ...(!val
          ? CYBER_CONSTANT.ACTIS.TOGGLE_TO_TARGET_VIEW
          : CYBER_CONSTANT.ACTIS.TOGGLE_TO_CURRENT_VIEW),
        ...actisData,
      },
      Constants.LABELS.ACTIS_KEY_CYBER,
    );

    setCurrentView(val);
    dispatch(setKpiData(localKpiDatas));
    setStatusBadges([]);
  };

  const handleDropDownOpen = (item, val) => {
    setSelectedValues((prev) => Object.keys(prev).reduce((prevValue, currValue) => {
      if (currValue === item) {
        return {
          ...prevValue,
          [currValue]: {
            ...val,
            openDropdown: true,
          },
        };
      }
      return {
        ...prevValue,
        [currValue]: {
          ...prev[currValue],
          openDropdown: false,
        },
      };
    }, {}));
  };

  const setDialogTooltip = (type, val) => {
    setDialog((item) => ({
      ...item,
      [type]: {
        ...item[type],
        tooltipVal: val,
      },
    }));
  };

  const lastUpdatedDate = useMemo(() => {
    const dates = Object.values(benchmarkForKpiData)
      ?.filter(Boolean)
      ?.map((item) => item.lastUpdatedDate);
    const exitsingDates = dates.filter((val) => val !== undefined);
    if (!exitsingDates.length) {
      return null;
    }
    return Math.max(...exitsingDates);
  }, [benchmarkForKpiData]);

  const lastUpdatedBy = useMemo(() => {
    const updatedByVal = Object.values(benchmarkForKpiData)
      ?.filter(Boolean)
      ?.filter((item) => item.lastUpdatedDate === lastUpdatedDate);
    return updatedByVal[0]?.lastUpdatedBy;
  }, [benchmarkForKpiData]);

  const handleSave = (data) => {
    const innerKpiData = kpiData.map((item, index) => {
      if (index === currentKpi) {
        return {
          ...item,
          ...data,
        };
      }
      return item;
    });
    dispatch(setKpiData(innerKpiData));
    setLocalKpiDatas(innerKpiData);

    setTimeout(() => {
      fetchBenchmarkForKpiData();
    }, 1000);
  };

  useEffect(() => {
    checkAndUpdateView(kpiData);
  }, [kpiData]);

  const shouldShowCyberLegend = useMemo(() => {
    if (currentView) {
      return (
        benchmarkForKpiData
        && Object.values(benchmarkForKpiData)?.some(
          (item) => item?.currentBenchmark?.percentile !== undefined,
        )
      );
    }
    return (
      benchmarkForKpiData
      && Object.values(benchmarkForKpiData)?.some(
        (item) => item?.targetBenchmark?.percentile !== undefined,
      )
    );
  }, [benchmarkForKpiData, currentView]);

  const shouldShowCyberTable = useMemo(
    () => benchmarkForKpiData
      && Object.values(benchmarkForKpiData)?.some(
        (item) => item?.currentBenchmark?.percentile !== undefined
          || item?.targetBenchmark?.percentile !== undefined,
      ),
    [benchmarkForKpiData, currentView],
  );

  const handleError = () => {
    setShowErrorComponent(true);
  };

  const hasEnoughDataForDownload = useMemo(() => Constants.DEFAULT_KPIS
    .some((kpiId) => (
      !!kpiData?.[kpiId - 1]?.curValue
      || kpiData?.[kpiId - 1]?.curValue === 0
    )), [kpiData]);

  const cyberStatesLabel = useMemo(() => {
    const totalAvailable = [];
    const totalUnavailable = [];
    const totalUnknow = [];

    const benchmarkStatusType = currentView
      ? CYBER_CONSTANT.LABEL.BENCHMARK_CURRENT
      : CYBER_CONSTANT.LABEL.BENCHMARK_TARGET;

    Object.values(benchmarkForKpiData)?.forEach(
      (item) => {
        if (item?.[benchmarkStatusType] === CYBER_CONSTANT.LABEL.AVAILABLE) {
          totalAvailable.push(item);
        } else if (item?.[benchmarkStatusType] === CYBER_CONSTANT.LABEL.UN_AVAILABLE) {
          totalUnavailable.push(item);
        } else {
          totalUnknow.push(item);
        }
      },
    );

    let availableStates = [];
    const benchmarkType = currentView
      ? CYBER_CONSTANT.LABEL.CURRENT_BENCHMARK
      : CYBER_CONSTANT.LABEL.TARGET_BENCHMARK;
    availableStates = totalAvailable.map(
      (itm) => CYBER_CONSTANT.STATES_LABEL[getStateFromPercentile(
        itm?.[benchmarkType]?.percentile,
      )],
    );

    const statesCounter = countOccurrences(availableStates);
    return {
      totalAvailable,
      availableStates,
      totalUnavailable,
      totalUnknow,
      statesCounter,
    };
  }, [benchmarkForKpiData, currentView, cohortSelection]);

  const handlePrint = () => {
    if (!hasEnoughDataForDownload) {
      return;
    }
    window.pushEvent?.(
      {
        ...CYBER_CONSTANT.ACTIS.DOWNLOAD_CYBER_REPORT,
        ...actisData,
      },
      Constants.LABELS.ACTIS_KEY_CYBER,
    );
    dispatch(setShowPrint(true));
  };

  const onHideDownloadTooltip = () => {
    setShouldShowTooltip(false);
  };

  const onShowDownloadTooltip = () => {
    if (!hasEnoughDataForDownload) {
      setShouldShowTooltip(true);
    }
  };

  const handleDropdownOpenedEvent = () => {
    setOpenDropdown(true);
    window.pushEvent?.(
      {
        ...CYBER_CONSTANT.ACTIS.SWITCH_DASHBOARD,
        ...actisData,
      },
      Constants.LABELS.ACTIS_KEY_CYBER,
    );
  };

  const handleClose = (item, count) => () => {
    dispatch(setCurrentDashboardDetails(item));
    window.pushEvent?.(
      {
        ...CYBER_CONSTANT.ACTIS.SELECT_DASHBOARD,
        ...actisData,
        activityMeta: `User clicks on Dashboard ${count} from Switch dashboard list`,
        activityValue: `Dashboard Values - 
          Org Name: ${item?.ownersOrgName},
          Role: ${item?.memberRole},
          Created By: ${item?.ownerName}`,
      },
      Constants.LABELS.ACTIS_KEY_CYBER,
    );
    setStatusBadges([]);
    setOpenDropdown(false);
  };

  const filterCards = (stateLabel) => () => {
    const benchmarkType = currentView
      ? CYBER_CONSTANT.LABEL.CURRENT_BENCHMARK
      : CYBER_CONSTANT.LABEL.TARGET_BENCHMARK;
    let localBadgeStatus = [];
    if (!statusBadges.includes(stateLabel)) {
      localBadgeStatus = [
        ...statusBadges,
        stateLabel,
      ];
      window.pushEvent?.(
        {
          ...CYBER_CONSTANT.ACTIS.SELECT_UNLOCKED,
          ...actisData,
          activityValue: `${cyberStatesLabel.statesCounter[stateLabel]} ${stateLabel}`,
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    } else {
      localBadgeStatus = statusBadges.filter((item) => (item !== stateLabel));
      window.pushEvent?.(
        {
          ...CYBER_CONSTANT.ACTIS.DESELECT_UNLOCKED,
          ...actisData,
          activityValue: `${cyberStatesLabel.statesCounter[stateLabel]} ${stateLabel}`,
        },
        Constants.LABELS.ACTIS_KEY_CYBER,
      );
    }

    const benchmarkStatusType = currentView
      ? CYBER_CONSTANT.LABEL.BENCHMARK_CURRENT
      : CYBER_CONSTANT.LABEL.BENCHMARK_TARGET;

    setStatusBadges(localBadgeStatus);
    if (localBadgeStatus?.length) {
      const localKpiData = localKpiDatas.filter((_, index) => (
        (localBadgeStatus?.includes(CYBER_CONSTANT.STATES_LABEL[getStateFromPercentile(
          benchmarkForKpiData[index + 1]?.[benchmarkType]?.percentile,
        )]))
        || (localBadgeStatus?.includes(benchmarkForKpiData[index + 1]?.[benchmarkStatusType]))
      ));
      dispatch(setKpiData(localKpiData));
    } else {
      dispatch(setKpiData(localKpiDatas));
    }
  };

  return (
    <AccessControlProvider permissions={permissions}>
      <Grid className="root-cyber">
        {(showLoader) && (
          <div className="progress-pptCyber">
            <Spinner />
          </div>
        )}
        <div className="mainContainer">
          {!showErrorComponent && !showLoader && (
            <>
              <CyberFirstContainer />
              <GravityLayout>
                <div className="secondPadding">
                  <div className="midContainer-cyberCreated">
                    {currentDashboardDetails?.ownersOrgName
                      && (
                        <div className="midContainer-switchField">
                          <Typography className="boldText">
                            {CYBER_CONSTANT.LABEL.ORG_NAME}
                          </Typography>
                          {currentDashboardDetails?.ownersOrgName}
                        </div>
                      )}
                    {currentDashboardDetails?.memberRole
                      && (
                        <div className="midContainer-switchField">
                          <Typography className="boldText">
                            {CYBER_CONSTANT.LABEL.ROLE}
                          </Typography>
                          {currentDashboardDetails?.memberRole}
                        </div>
                      )}
                    {currentDashboardDetails?.ownerName
                      && (
                        <div className="midContainer-switchField">
                          <Typography className="boldText">
                            {CYBER_CONSTANT.LABEL.CREATED_BY}
                          </Typography>
                          {currentDashboardDetails?.ownerName}
                        </div>
                      )}
                    {(lastUpdatedDate && lastUpdatedBy && currentDashboardDetails?.dashboardId)
                      && (
                        <div className="midContainer-switchField">
                          <Typography className="boldText">
                            {CYBER_CONSTANT.LABEL.LAST_UPDATED_AT}
                          </Typography>
                          {`${format(lastUpdatedDate, CYBER_CONSTANT.DO_DATE_FORMAT)} by ${trimText(lastUpdatedBy, CYBER_CONSTANT.LAST_MODIFIED_LIMIT)}`}
                        </div>
                      )}
                    {(lastUpdatedDate && !lastUpdatedBy && currentDashboardDetails?.dashboardId)
                      && (
                        <div className="midContainer-switchField">
                          <Typography className="boldText">
                            {CYBER_CONSTANT.LABEL.LAST_UPDATED_AT}
                          </Typography>
                          {format(lastUpdatedDate, CYBER_CONSTANT.DO_DATE_FORMAT)}
                        </div>
                      )}
                    {(!lastUpdatedDate && lastUpdatedBy && currentDashboardDetails?.dashboardId)
                      && (
                        <div className="midContainer-switchField">
                          <Typography className="boldText">
                            {CYBER_CONSTANT.LABEL.LAST_UPDATED_AT}
                          </Typography>
                          {`by ${trimText(lastUpdatedBy, CYBER_CONSTANT.LAST_MODIFIED_LIMIT)}`}
                        </div>
                      )}
                  </div>
                  {allDashboardDetails?.length > 1
                    && (
                      <Dropdown
                        className="midContainer-cyberDivTwo"
                        classNameContainer="midContainer-cyberContainer"
                        open={openDropdown}
                        openedEvent={handleDropdownOpenedEvent}
                        menuNode={
                          (
                            <span
                              style={{
                                padding: '10px 10px 10px 0px',
                                display: 'inline-block',
                              }}
                            >
                              {CYBER_CONSTANT.LABEL.SWITCH_DASH}
                            </span>
                          )
                        }
                      >
                        {allDashboardDetails.map((item, index) => (
                          <DropdownItem
                            selected
                            onClick={handleClose(item, index)}
                            className={currentDashboardDetails?.dashboardId === item?.dashboardId ? 'midContainer-switchDashNameHigh' : 'midContainer-switchDashName'}
                            key={item?.dashboardId}
                          >
                            {`${CYBER_CONSTANT.LABEL.DASHBOARD} ${index + 1}`}
                            {currentDashboardDetails?.dashboardId === item?.dashboardId
                            && (
                              <div className="midContainer-cyberDivOne">
                                {item?.ownersOrgName
                                  && (
                                    <div className="midContainer-switchField smallFont">
                                      <Typography className="boldText">
                                        {CYBER_CONSTANT.LABEL.ORG_NAME}
                                      </Typography>
                                      {item?.ownersOrgName}
                                    </div>
                                  )}
                                {item?.memberRole
                                  && (
                                    <div className="midContainer-switchField smallFont">
                                      <Typography className="boldText">
                                        {CYBER_CONSTANT.LABEL.ROLE}
                                      </Typography>
                                      {item?.memberRole}
                                    </div>
                                  )}
                                {item?.ownerName
                                  && (
                                    <div className="midContainer-switchField smallFont">
                                      <Typography className="boldText">
                                        {CYBER_CONSTANT.LABEL.CREATED_BY}
                                      </Typography>
                                      {item?.ownerName}
                                    </div>
                                  )}
                              </div>
                            )}
                          </DropdownItem>
                        ))}
                      </Dropdown>
                    )}
                </div>
              </GravityLayout>
              <div className="secondContainer-cyber">
                <GravityLayout>
                  <Grid className="thirdPadding">
                    {(isVersionTwoEnabled && currentDashboardDetails?.dashboardId) && (
                      <>
                        {/* <div className="cyberUpdateToolbar">
                          <AccessControl
                            featureId={Constants.PERMISSIONS.EDIT_PEER_COMPARISION_GROUP}
                          >
                            <CyberComparisonSelectedFilter
                              cohortSelection={cohortSelection}
                              dashboardId={currentDashboardDetails?.dashboardId}
                            />
                          </AccessControl>

                          <div className="cyberToolbarActionButtons">
                            <AccessControl featureId={Constants.PERMISSIONS.MANAGE_TEAM}>
                              <Button
                                variant="ghost"
                                onClick={openShareDialog}
                                className="cyberToolbarActionAssignTeam"
                              >
                                <GroupAddOutlinedIcon />
                                {inviteMemberCount > CYBER_CONSTANT.LABEL.SHOW_MANAGE_LIST
                                  ? CYBER_CONSTANT.LABEL.MANAGE_TEAM
                                  : CYBER_CONSTANT.LABEL.ASSIGN_TEAM}
                              </Button>
                            </AccessControl>
                            <AccessControl featureId={Constants.PERMISSIONS.DOWNLOAD_RESULT}>
                              {isVersionTwoEnabled && !showPrint && (
                              <Tooltip
                                className="tooltipDownload"
                                open={shouldShowTooltip}
                                hideCloseButton
                                onMouseLeave={onHideDownloadTooltip}
                                title={CYBER_CONSTANT.LABEL.RESULT_NOT_AVAILABLE}
                              >
                                <div onMouseEnter={onShowDownloadTooltip}>
                                  <Button
                                    variant="ghost"
                                    onClick={handlePrint}
                                    className="cyberToolbarActionAssignTeam"
                                    disabled={!hasEnoughDataForDownload
                                      || (cyberStatesLabel?.totalUnavailable?.length
                                        === CYBER_CONSTANT.LABEL.KPI_CARDS)}
                                    disableRipple
                                  >
                                    <DownloadOutlinedIcon
                                      sx={{
                                        marginLeft: isResponsive ? 0.4 : 0,
                                      }}
                                    />
                                    {CYBER_CONSTANT.LABEL.DOWNLOAD}
                                  </Button>
                                </div>
                              </Tooltip>
                              )}
                            </AccessControl>
                          </div>
                        </div> */}
                        <div className="cyberUnlockedStatusDiv">
                          <div className="cyberUnlockedDiv">
                            <Typography className="unlockedVal">
                              {cyberStatesLabel.totalAvailable.length
                                + cyberStatesLabel.totalUnavailable.length}
                            </Typography>
                            <Typography className="unlockedText">
                              {CYBER_CONSTANT.LABEL.UNLOCKED_BENCH}
                            </Typography>
                          </div>
                          {cyberStatesLabel?.totalAvailable?.length > 0
                            && (
                              <div className="cyberUnlockedDivider" />
                            )}
                          <div className="cyberUnlockedDivTwo">
                            {/* <div>
                              {cyberStatesLabel?.totalAvailable?.length > 0 && (
                                <div
                                  className="unavailNum"
                                >
                                  {
                                    `${cyberStatesLabel?.totalAvailable?.length}
                                    ${CYBER_CONSTANT.LABEL.AVAILABLE}`
                                  }
                                </div>
                              )}
                              {cyberStatesLabel.totalUnavailable.length > 0 && (
                                <div
                                  className="unavailNum"
                                >
                                  {`${cyberStatesLabel?.totalUnavailable?.length}
                                  ${CYBER_CONSTANT.LABEL.UN_AVAILABLE}`}
                                </div>
                              )}
                            </div> */}
                            <div className="avaiDataDiv">
                              {cyberStatesLabel?.totalAvailable?.length > 0 && (
                                <div className="avaiData">
                                  {cyberStatesLabel?.availableStates?.includes(
                                    CYBER_CONSTANT.STATES_LABEL.LAGGING,
                                  ) && (
                                    <div
                                      className={statusBadges.includes(CYBER_CONSTANT.STATES_LABEL.LAGGING) ? 'avaiVal selectedItem' : 'avaiVal'}
                                      onClick={filterCards(CYBER_CONSTANT.STATES_LABEL.LAGGING)}
                                      role="link"
                                      tabIndex={0}
                                    >
                                      {`${cyberStatesLabel.statesCounter[CYBER_CONSTANT.STATES_LABEL.LAGGING]} ${CYBER_CONSTANT.STATES_LABEL.LAGGING}`}
                                    </div>
                                  )}
                                  {cyberStatesLabel?.availableStates?.includes(
                                    CYBER_CONSTANT.STATES_LABEL.MID_LAGGING,
                                  ) && (
                                    <div
                                      className={
                                        statusBadges.includes(
                                          CYBER_CONSTANT.STATES_LABEL.MID_LAGGING,
                                        )
                                          ? 'avaiVal selectedItem'
                                          : 'avaiVal'
                                      }
                                      onClick={
                                        filterCards(CYBER_CONSTANT.STATES_LABEL.MID_LAGGING)
                                      }
                                      role="link"
                                      tabIndex={0}
                                    >
                                      {`${cyberStatesLabel.statesCounter[CYBER_CONSTANT.STATES_LABEL.MID_LAGGING]} ${CYBER_CONSTANT.STATES_LABEL.MID_LAGGING}`}
                                    </div>
                                  )}
                                  {cyberStatesLabel?.availableStates?.includes(
                                    CYBER_CONSTANT.STATES_LABEL.MID_RANGE,
                                  ) && (
                                    <div
                                      className={
                                        statusBadges.includes(
                                          CYBER_CONSTANT.STATES_LABEL.MID_RANGE,
                                        )
                                          ? 'avaiVal selectedItem'
                                          : 'avaiVal'
                                      }
                                      onClick={
                                        filterCards(CYBER_CONSTANT.STATES_LABEL.MID_RANGE)
                                      }
                                      role="link"
                                      tabIndex={0}
                                    >
                                      {`${cyberStatesLabel.statesCounter[CYBER_CONSTANT.STATES_LABEL.MID_RANGE]} ${CYBER_CONSTANT.STATES_LABEL.MID_RANGE}`}
                                    </div>
                                  )}
                                  {cyberStatesLabel?.availableStates?.includes(
                                    CYBER_CONSTANT.STATES_LABEL.MID_LEADING,
                                  ) && (
                                    <div
                                      className={
                                        statusBadges.includes(
                                          CYBER_CONSTANT.STATES_LABEL.MID_LEADING,
                                        )
                                          ? 'avaiVal selectedItem'
                                          : 'avaiVal'
                                        }
                                      onClick={
                                        filterCards(CYBER_CONSTANT.STATES_LABEL.MID_LEADING)
                                      }
                                      role="link"
                                      tabIndex={0}
                                    >
                                      {`${cyberStatesLabel.statesCounter[CYBER_CONSTANT.STATES_LABEL.MID_LEADING]} ${CYBER_CONSTANT.STATES_LABEL.MID_LEADING}`}
                                    </div>
                                  )}
                                  {cyberStatesLabel?.availableStates?.includes(
                                    CYBER_CONSTANT.STATES_LABEL.LEADING,
                                  ) && (
                                    <div
                                      className={statusBadges.includes(CYBER_CONSTANT.STATES_LABEL.LEADING) ? 'avaiVal selectedItem' : 'avaiVal'}
                                      onClick={filterCards(CYBER_CONSTANT.STATES_LABEL.LEADING)}
                                      role="link"
                                      tabIndex={0}
                                    >
                                      {`${cyberStatesLabel.statesCounter[CYBER_CONSTANT.STATES_LABEL.LEADING]} ${CYBER_CONSTANT.STATES_LABEL.LEADING}`}
                                    </div>
                                  )}
                                </div>
                              )}
                              {cyberStatesLabel.totalUnavailable.length > 0 && (
                                <div className="unavailText">
                                  <div
                                    className={statusBadges.includes(CYBER_CONSTANT.LABEL.UN_AVAILABLE) ? 'avaiVal selectedItem' : 'avaiVal'}
                                    onClick={filterCards(CYBER_CONSTANT.LABEL.UN_AVAILABLE)}
                                    role="link"
                                    tabIndex={0}
                                  >
                                    {`${cyberStatesLabel.totalUnavailable.length} ${CYBER_CONSTANT.LABEL.UN_AVAILABLE}`}
                                  </div>
                                  {CYBER_CONSTANT.LABEL.ADJUST_PEERS}
                                </div>
                              )}
                              {(permissions.includes(Constants.PERMISSIONS.MANAGE_TEAM)
                                || permissions.includes(Constants.PERMISSIONS.DOWNLOAD_RESULT))
                                && (
                                  <div className="cyberUnlockedDivider" />
                                )}
                              <div className="cyberToolbarActionButtons">
                                <AccessControl featureId={Constants.PERMISSIONS.MANAGE_TEAM}>
                                  <Button
                                    variant="ghost"
                                    onClick={openShareDialog}
                                    className="cyberToolbarActionAssignTeam"
                                  >
                                    <GroupAddOutlinedIcon />
                                    {inviteMemberCount > CYBER_CONSTANT.LABEL.SHOW_MANAGE_LIST
                                      ? CYBER_CONSTANT.LABEL.MANAGE_TEAM
                                      : CYBER_CONSTANT.LABEL.ASSIGN_TEAM}
                                  </Button>
                                </AccessControl>
                                <AccessControl
                                  featureId={Constants.PERMISSIONS.DOWNLOAD_RESULT}
                                >
                                  {isVersionTwoEnabled && !showPrint && (
                                  <Tooltip
                                    className="tooltipDownload"
                                    open={shouldShowTooltip}
                                    hideCloseButton
                                    onMouseLeave={onHideDownloadTooltip}
                                    title={CYBER_CONSTANT.LABEL.RESULT_NOT_AVAILABLE}
                                  >
                                    <div onMouseEnter={onShowDownloadTooltip}>
                                      <Button
                                        variant="ghost"
                                        onClick={handlePrint}
                                        className="cyberToolbarActionAssignTeam"
                                        disabled={!hasEnoughDataForDownload
                                          || (cyberStatesLabel?.totalUnavailable?.length
                                            === CYBER_CONSTANT.LABEL.KPI_CARDS)}
                                        disableRipple
                                      >
                                        <DownloadOutlinedIcon
                                          sx={{
                                            marginLeft: isResponsive ? 0.4 : 0,
                                          }}
                                        />
                                        {CYBER_CONSTANT.LABEL.DOWNLOAD}
                                      </Button>
                                    </div>
                                  </Tooltip>
                                  )}
                                </AccessControl>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cyberToolbarAction">
                          <div className="cyberComparisonMetic">
                            <Typography className="cyberComparisonContent">
                              {`${CYBER_CONSTANT.LABEL.BENCHMARK_VIEW} `}
                            </Typography>
                            <div
                              onClick={toggleCurrentView(true)}
                              role="link"
                              tabIndex={0}
                              className={currentView ? 'cyberCurrentActive' : 'cyberCurrentInactive'}
                            >
                              {`${CYBER_CONSTANT.LABEL.CURRENT} ${CYBER_CONSTANT.LABEL.METRIC_VIEW}`}
                            </div>
                            <div
                              onClick={toggleCurrentView(false)}
                              role="link"
                              tabIndex={0}
                              className={!currentView ? 'cyberCurrentActive' : 'cyberCurrentInactive'}
                            >
                              {`${CYBER_CONSTANT.LABEL.TARGET} ${CYBER_CONSTANT.LABEL.METRIC_VIEW}`}
                            </div>
                          </div>
                          {shouldShowCyberLegend && <CyberLegends />}
                        </div>
                      </>
                    )}
                    <div className="kpiGroup">
                      {kpiData?.map((item, index) => (
                        <KpiCard
                          key={item.header}
                          index={index}
                          sideDrawer={sideDrawer}
                          isVersionTwoEnabled={isVersionTwoEnabled}
                          currentView={currentView}
                          benchmarkForKpiData={benchmarkForKpiData}
                          item={item}
                        />
                      ))}
                    </div>
                    <Drawer
                      open={openDrawer}
                      onClose={sideDrawer(false, currentKpi)}
                      className="drawer"
                      closeOnBackdropClick={false}
                      anchor="right"
                    >
                      <DrawerComponent
                        key={openDrawer}
                        shouldShowCyberLegend={shouldShowCyberTable}
                        handleError={handleError}
                        handleSave={handleSave}
                        handleClose={sideDrawer(false, currentKpi)}
                        isVersionTwoEnabled={isVersionTwoEnabled}
                        isLoadingBenchmark={isLoadingBenchmark}
                        actisData={actisData}
                        kpiItem={kpiData[currentKpi]}
                        minimalBenchmarkData={minimalBenchmarkData}
                        benchmarkForKpi={
                          benchmarkForKpiData?.[kpiData[currentKpi]?.kpiId]
                        }
                        kpiRecommendedResources={kpiResources?.recommendedResources}
                        showResourcesLoader={showResourcesLoader}
                        dashboardId={currentDashboardDetails?.dashboardId}
                        drawerStatus={openDrawer}
                      />
                    </Drawer>
                    <AssignTeam
                      open={shareDialogStatus}
                      onClose={closeShareDialog}
                      actisDataObj={actisDataObj}
                      dashboardId={currentDashboardDetails?.dashboardId}
                      dashboardList={dashboardList}
                    />
                    {(recommendedTools?.length > 0 || recommendedResources?.length > 0) && (
                      <div className="whatsNextDiv">
                        <Typography className="whatsNext">
                          {CYBER_CONSTANT.LABEL.WHATS_NEXT}
                        </Typography>
                        {(recommendedTools?.length > 0) && (
                          <div className="recommendedDataDiv">
                            <Typography className="recommendedTitle">
                              {CYBER_CONSTANT.LABEL.RECOMMENDED_TOOLS}
                            </Typography>
                            <CarousalComponent data={recommendedTools} actisData={actisData} />
                          </div>
                        )}
                        {(recommendedResources?.length > 0) && (
                          <div className="recommendedDataDiv">
                            <Typography className="recommendedTitle">
                              {CYBER_CONSTANT.LABEL.RECOMMENDED_RESOURCES}
                            </Typography>
                            <CarousalComponent
                              isRR
                              data={recommendedResources}
                              actisData={actisData}
                            />
                            <Typography className="recommendedNote">
                              {CYBER_CONSTANT.LABEL.RESOURCE_NOTE}
                            </Typography>
                          </div>
                        )}
                      </div>
                    )}
                    <ComparisonDialog
                      openDialogGroup={openDialogGroup}
                      optIn={optIn}
                      selectedValues={selectedValues}
                      dialog={dialog}
                      handleDropDownOpen={handleDropDownOpen}
                      handleChange={handleChange}
                      displayList={displayList}
                      defaultValues={defaultValues}
                      setDialogTooltip={setDialogTooltip}
                      handleAgree={handleAgree}
                      showSubmit={showSubmit}
                      actisDataObj={actisDataObj}
                    />

                    <SnackbarComponent
                      msg={Constants.ERROR.SUCCESS_ERROR}
                      onClose={() => handleSnackbar()}
                      variant={Constants.SNACKBAR.SUCCESS}
                      open={showSuccess}
                    />
                  </Grid>
                </GravityLayout>
              </div>
            </>
          )}
          {showErrorComponent && (
            <ErrorPage
              actisDataObj={actisDataObj}
              actisKey={Constants.LABELS.ACTIS_KEY_CYBER}
            />
          )}
        </div>
      </Grid>
    </AccessControlProvider>
  );
}

Cyber.propTypes = {
  actisDataObj: PropTypes.instanceOf(Object),
  userData: PropTypes.instanceOf(Object),
};

Cyber.defaultProps = {
  actisDataObj: {},
  userData: {},
};

export default Cyber;
